import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Dialog,
    TextField,
    Typography,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@material-ui/core";
import popupStyles from "./Popup.style";
import apiService from "../../../../services/apiService";


const Popup = ({
    selectedLine,
    setSelectedLine,
    openDialog,
    setOpenDialog,
    setLoading,
    user,
    User,
    setError,
    setHistoryKey,
}) => {
    const [actionDescription, setActionDescription] = useState("");
    const [history, setHistory] = useState([]);
    const [disableApproval, setDisableApproval] = useState(false);
    const [recentAction, setRecentAction] = useState(null);
    const [nicknamesMap, setNicknamesMap] = useState({});
    const [mealsAmount, setMealsAmount] = useState(1);

    useEffect(() => {
        const fetchNicknames = async () => {
            const idsToFetch = [...new Set(history.map((item) => item.updatedBy))].filter(
                (id) => id && !nicknamesMap[id]
            );

            if (idsToFetch.length === 0) return;

            const updatedMap = { ...nicknamesMap };

            await Promise.all(
                idsToFetch.map(async (id) => {
                    try {
                        const response = await apiService.post("/users/getUserNicknameById", { userId: id });
                        updatedMap[id] = response.data.nickname || id;
                    } catch (err) {
                        console.error(`שגיאה בשליפת nickname ל־${id}:`, err);
                        updatedMap[id] = id;
                    }
                })
            );
            setNicknamesMap(updatedMap);
        };

        if (history.length) {
            fetchNicknames();
        }
    }, [history]);

    useEffect(() => {
        const fetchHistory = async () => {
            if (!user?.PersonID) return;
            try {
                setLoading(true);
                const response = await apiService.get(`/departmentsUpdate/history/${user.PersonID}`);
                setHistory(response.data);
            } catch (err) {
                setError("שגיאה בטעינת ההיסטוריה");
            } finally {
                setLoading(false);
            }
        };

        fetchHistory();
    }, [user?.PersonID]);

    useEffect(() => {
        if (!selectedLine || selectedLine._id !== 3) {
            setDisableApproval(false);
            setRecentAction(null);
            return;
        }

        const now = new Date();
        const last48Hours = new Date(now.getTime() - 48 * 60 * 60 * 1000);

        const found = history.find((entry) => {
            const createdAt = new Date(entry.createdAt);
            const isRecent = createdAt > last48Hours;
            const isSameAction = entry.action === 3;
            return isSameAction && isRecent;
        });

        if (found) {
            setDisableApproval(true);
            setRecentAction(found);
        } else {
            setDisableApproval(false);
            setRecentAction(null);
        }
    }, [selectedLine, history]);

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setMealsAmount(1);
        setActionDescription("");
        setSelectedLine(null);
    };

    const handleConfirm = async () => {
        if (!selectedLine || !user) return;

        setLoading(true);
        setError(null);

        try {
            const payload = {
                personId: Number(user.PersonID),
                action: selectedLine._id,
                actionDescription,
                updatedBy: User.userId,
                createdAt: new Date(),
                ...(selectedLine._id === 2 && { mealsCount: mealsAmount }),
            };

            await apiService.post("/departmentsUpdate/add", payload);

            const updatedHistory = await apiService.get(
                `/departmentsUpdate/history/${user.PersonID}`
            );
            setHistory(updatedHistory.data);

            setHistoryKey((prev) => prev + 1);
        } catch (err) {
            console.error(err);
            setError("שגיאה בשליחת הפעולה לשרת");
        } finally {
            setLoading(false);
            handleCloseDialog();
        }
    };

    return (
        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="xs" fullWidth>
            <DialogTitle disableTypography>
                <Box position="relative" textAlign="center">
                    <Typography variant="h6">אישור פעולה</Typography>

                    <Button onClick={handleCloseDialog} style={popupStyles.closeButton}>
                        ✖
                    </Button>
                </Box>
            </DialogTitle>

            <DialogContent dividers>
                <Typography gutterBottom>
                    האם לאשר את הפעולה: <b>{selectedLine?.actionName}</b>?
                </Typography>
                {disableApproval && recentAction && (
                    <Box style={popupStyles.recentActionBox}>
                        <Typography style={popupStyles.recentActionTitle}>
                            פעולה זו כבר בוצעה ב־48 השעות האחרונות
                        </Typography>

                        <Typography style={popupStyles.recentActionSubtitle}>
                            על ידי <b>{nicknamesMap[recentAction.updatedBy] || recentAction.updatedBy}</b> בתאריך{" "}
                            <b>{new Date(recentAction.createdAt).toLocaleString("he-IL")}</b>
                        </Typography>
                    </Box>
                )}

                {selectedLine?._id === 2 && (
                    <Box style={popupStyles.textFieldBox}>
                        <Typography gutterBottom>
                            {user.Survivor && "ניצול שואה - מגיע לו ארוחה מתנה"}
                        </Typography>

                        <Box display="flex" gap={1}>
                            {[1, 2, 3, 4, 5].map((amount) => (
                                <Button
                                    key={amount}
                                    variant={mealsAmount === amount ? "contained" : "outlined"}
                                    color="primary"
                                    onClick={() => setMealsAmount(amount)}
                                >
                                    {amount}
                                </Button>
                            ))}
                        </Box>
                    </Box>
                )}

                {selectedLine?._id == 5 && (
                    <Box style={popupStyles.textFieldBox}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="תיאור"
                            multiline
                            minRows={1}
                            value={actionDescription}
                            onChange={(e) => setActionDescription(e.target.value)}
                            inputProps={{
                                maxLength: 100,
                                style: popupStyles.textFieldInput,
                            }}
                        />
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog} color="secondary">
                    ביטול
                </Button>
                <Button onClick={handleConfirm} color="primary" disabled={disableApproval} variant="contained">
                    אישור
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default Popup;
